<template>
  <svg id="Ebene_1"
       xmlns="http://www.w3.org/2000/svg"
       xmlns:xlink="http://www.w3.org/1999/xlink"
       x="0"
       y="0"
       version="1.1"
       viewBox="0 0 769.5 591.9"
       style="enable-background:new 0 0 769.5 591.9"
       xml:space="preserve">
    <g><path d="M384.8,344.4L384.8,344.4c-92.5,0-167.2-74.7-167.2-167.2l0,0C217.6,84.7,292.3,10,384.8,10l0,0 C477.3,10,552,84.7,552,177.2l0,0C552,269.6,477.3,344.4,384.8,344.4z" /><path d="M474.2,152.2h-32.8v49.5h32.8c13.7,0,24.9-11.3,24.9-24.9S487.9,152.2,474.2,152.2" class="st0" /><path d="M280.7,177.1c0,38.2,31.1,69.3,69.3,69.3c38.2,0,69.3-31.1,69.3-69.3s-31.1-69.3-69.3-69.3 C311.8,107.8,280.7,138.9,280.7,177.1L280.7,177.1" class="st0" /><g><path d="M221.6,461.9v69.7c0,15-9.3,25.6-22,25.6h-6.2c-13,0-22-10.6-22-25.6v-69.7h-24.5V536c0,26.7,19.2,45.9,46.1,45.9h7.1 c26.9,0,45.9-19.2,45.9-45.9v-74.1H221.6z M445.2,504.3l45.4-47.8h-34.2l-39.9,43v-71.2h-24.2v151.7h24.2v-44.5l11.7-12.3 l39.9,56.9h30L445.2,504.3z M63.6,555.6H34.2V452.7h29.3c22.7,0,40.8,23.1,40.8,51.1C104.3,532.7,86.3,555.6,63.6,555.6z M63.6,428H10v152.1h53.6c35.9,0,65.3-33.9,65.3-76.3C128.8,462.4,99.5,428,63.6,428z M568.2,555.6h-28.9V452.7h28.9 c22.9,0,40.8,23.1,40.8,51.1C608.9,532.7,591.1,555.6,568.2,555.6z M568.2,428h-53.3v152.1h53.3c36.4,0,65.3-33.9,65.3-76.3 C633.4,462.4,604.5,428,568.2,428z M714.3,555.6h-37.7v-42.1h37.7c11.2,0,20.9,9.7,20.9,20.9C735.3,546.4,725.6,555.6,714.3,555.6 z M676.6,489v-36.4h30c10.1,0,18.3,7.9,18.3,18.1c0,10.1-8.2,18.3-18.3,18.3H676.6z M740.1,497.2c5.5-7.3,9.3-16.5,9.3-26.5 c0-23.4-19.6-42.8-42.8-42.8h-54.2v152.1h61.9c25.1,0,45.2-20.5,45.2-45.6C759.5,519,752,505.6,740.1,497.2z M315.1,484.6h6 c14.5,0,26.5,10.6,26.5,23.8h24.7c0-26.2-23.1-47.8-51.1-47.8h-6c-27.6,0-49.8,22.3-49.8,49.6V532c0,27.6,22.3,49.8,49.8,49.8h6 c28.9,0,52.5-21.6,52.5-47.6h-24.7c0,12.6-12.6,22.9-27.8,22.9h-6c-14.1,0-25.8-11.2-25.8-25.1v-21.8 C289.3,496.1,301,484.6,315.1,484.6z" /></g></g>
  </svg>
</template>

<script>
export default {
  props: {
    // color: {
    //   type: String,
    //   default: "#FFFF00"
    // }
  }
}
</script>

<style scoped type="text/css">
.st0 {
  fill: #FFC000;
}
.st1 {
  fill: #FFFF00;
}
.st2 {
  fill: #ffffff;
}
</style>
